import React from "react";
import "./RequestInformation.css";
import { Link } from "react-router-dom";

const RequestInformation = () => {
	return (
		<div className='uiowa-request-information'>
			<div className='content  d-flex align-items-center justify-content-space-between'>
				<p>BE A HAWKEYE</p>
				<p>
					Iowa is where great stories begin.
					<br /> It's time to start yours. Find out how.
				</p>
				<Link className='btnUiowa d-flex  gap-3'>
					REQUEST INFORMATION
					<span>
						<i
							className='fa fa-arrow-right'
							style={{ color: "#fff" }}
							aria-hidden='true'
						></i>
					</span>
				</Link>
			</div>
		</div>
	);
};

export default RequestInformation;
